module.exports = __webpack_public_path__ + "static/media/garden_store_delivery_truck_graphic_concepts_2020.4e9e3884.webp";